import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { colorMap, ColorNames, SecondaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
      height: '100%',
      '& .medium-tiles, .small-tiles': {
        '& #collection-items': {
          '& ul:not(.share-single)': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '32px',
            [muiTheme.breakpoints.up('md')]: {
              flexDirection: 'row',
            },

            '& li.tile.single': {
              '&:hover a': {
                textDecoration: 'none',
              },

              '& .img.visible img': {
                marginLeft: '0 !important',
                minWidth: '100% !important',
              },

              '& .description': {
                backgroundColor: `${colorMap['dark-gray']} !important`,

                '& h3': {
                  ...typography.h6,
                  color: `${ColorNames.white} !important`,
                  lineHeight: '1.55 !important',
                },

                '& .friendly-timestamp': {
                  ...typography.caption,
                  color: SecondaryColors.dark,

                  '& abbr': {
                    textDecoration: 'none !important',
                  },
                },
              },
              '& > a.item-link.view': {
                backgroundColor: `${colorMap['dark-gray']} !important`,
                border: `solid 1px ${SecondaryColors.dark} !important`,
                width: 'auto',
                borderRadius: '4px',
                color: `${colorMap.white} !important`,
                backgroundImage: 'none !important',
                minWidth: '150px',
                padding: '0 15px',
                margin: '0 20px !important',
                textAlign: 'center',
                bottom: '20px',
                left: 0,
                right: 0,
                '&:before': {
                  content: '""',
                  backgroundImage: 'unset !important',
                },
                '&:after': {
                  content: '""',
                  backgroundImage: 'unset !important',
                },
                '&:hover': {
                  border: '1px solid #00aeef',
                  backgroundColor: `${colorMap.charcoal}!important`,
                  transition: 'all ease-in-out .2s',
                },
              },
              '& .share-single.four': {
                margin: '0 0 0 4em !important',
                '& li': {
                  border: 'none',
                  '&:not(:last-of-type)': {
                    borderRight: 'solid 1px',
                  },
                },

                '& li a': {
                  backgroundColor: `${colorMap.charcoal} !important`,
                },
              },
            },
          },
        },
      },
    },
  }),
  { name: 'GenEmbeddedContent' },
);

export default useStyles;
